import _typeof from "@babel/runtime/helpers/typeof";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var AbortSignalFacade = /*#__PURE__*/_createClass(function AbortSignalFacade() {
  _classCallCheck(this, AbortSignalFacade);
  _defineProperty(this, "aborted", false);
  _defineProperty(this, "reason", '');
  _defineProperty(this, "onabort", function () {});
  _defineProperty(this, "throwIfAborted", function () {});
  _defineProperty(this, "addEventListener", function () {});
  _defineProperty(this, "removeEventListener", function () {});
  _defineProperty(this, "dispatchEvent", function () {
    return false;
  });
});
export var AbortControllerFacade = /*#__PURE__*/function () {
  function AbortControllerFacade() {
    _classCallCheck(this, AbortControllerFacade);
    _defineProperty(this, "signal", new AbortSignalFacade());
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.AbortController) {
      var controller = new AbortController();
      this.abort = controller.abort.bind(controller);
      this.signal = controller.signal;
    }
  }
  _createClass(AbortControllerFacade, [{
    key: "abort",
    value: function abort() {}
  }]);
  return AbortControllerFacade;
}();